import type {
  ProspectAuditInstagramDto,
  ProspectAuditOnlyFansDto,
  ProspectAuditTikTokDto,
  ProspectDto,
} from '@api'

export enum SocialAuditStatus {
  Good = 'Good',
  Warning = 'Warning',
  Critical = 'Critical',
}

export interface AuditOption<T> {
  label: string
  description: string
  conditions: {
    statusLabel?: string
    status: SocialAuditStatus
    dynamicStatusLabel?: (row: T) => string
    comment: string
    check: (row: T) => boolean
  }[]
}

export interface AuditOptionWithStatus<T>
  extends Omit<AuditOption<T>, 'conditions'> {
  statusLabel: string
  statusColor: string
  comment: string
}

export interface FormattedSocialAuditItem<T> {
  type: 'instagram' | 'tiktok'
  accountUrl: string
  avatarUrl: string | undefined
  options: AuditOptionWithStatus<T>[]
  overall: { [key: string]: number }
  percentage: number
  chartImage: string
}

export interface FormattedAudit {
  info: ProspectDto | undefined
  onlyfans: ProspectAuditOnlyFansDto[]
  tiktok: FormattedSocialAuditItem<ProspectAuditTikTokDto>[]
  instagram: FormattedSocialAuditItem<ProspectAuditInstagramDto>[]
}
